import { useState, useEffect, useCallback } from "react";
import servicesService from "../services/ServicesService";

const POLL_MS = 4000;

function mapResponse(response) {
  if (!response) {
    return {
      isEmbeddedSignup: 0,
      isContact: "not-started",
      isHistory: "not-started",
      chunkData: {},
    };
  }
  return {
    isEmbeddedSignup: response.getIsEmbeddedSignup?.() ?? 0,
    isContact: response.getIsContactSync?.() ?? "not-started",
    isHistory: response.getIsHistorySync?.() ?? "not-started",
    chunkData: response.getChunkData?.() ?? {},
  };
}

/**
 * Loads WhatsApp sync fields and polls while contact or history sync is in progress
 * (server updates progress via webhooks; client refreshes from API).
 */
export default function useWhatsappEmbeddedSyncState() {
  const [whatsapp, setWhatsapp] = useState(() => mapResponse(null));

  const fetchWhatsapp = useCallback(async () => {
    try {
      const response = await servicesService.getWhatsapp();
      setWhatsapp(mapResponse(response));
    } catch {
      setWhatsapp(mapResponse(null));
    }
  }, []);

  useEffect(() => {
    fetchWhatsapp();
  }, [fetchWhatsapp]);

  useEffect(() => {
    const needsPoll =
      whatsapp.isHistory === "in-progress" ||
      whatsapp.isContact === "in-progress";
    if (!needsPoll) return undefined;
    const id = setInterval(() => {
      fetchWhatsapp();
    }, POLL_MS);
    return () => clearInterval(id);
  }, [whatsapp.isHistory, whatsapp.isContact, fetchWhatsapp]);

  const handleSync = useCallback(
    async (type) => {
      await servicesService.syncHistory(type);
      await fetchWhatsapp();
    },
    [fetchWhatsapp]
  );

  return { whatsapp, fetchWhatsapp, handleSync };
}
